import { render, staticRenderFns } from "./LLTabs.vue?vue&type=template&id=a0f7e176&scoped=true"
import script from "./LLTabs.vue?vue&type=script&lang=js"
export * from "./LLTabs.vue?vue&type=script&lang=js"
import style0 from "./LLTabs.vue?vue&type=style&index=0&id=a0f7e176&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f7e176",
  null
  
)

export default component.exports